/* eslint-disable react/prop-types */
/* eslint-disable @calm/react-intl/missing-formatted-message */
import React, { useState } from "react";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig"; // Firebase configuration
import QRCode from "react-qr-code"; // For generating QR codes
const OTPAuth = require("otpauth");
import "./FirebaseLogin.scss"; // Styles

function FirebaseLogin({ onTotpSuccess }) {
  const [email, setEmail] = useState("");
  const [totpSecret, setTotpSecret] = useState("");
  const [isSetupComplete, setIsSetupComplete] = useState(false);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [totpCode, setTotpCode] = useState("");
  const [error, setError] = useState(null);

  // Save TOTP secret to Firestore
  const saveTotpSecret = async (email, secret) => {
    try {
      await setDoc(doc(db, "users", email), { email, totpSecret: secret });
      console.log("Authenticator secret saved successfully!");
    } catch (err) {
      console.error("Error saving authenticator secret:", err);
    }
  };

  // Fetch TOTP secret from Firestore
  const fetchTotpSecret = async email => {
    try {
      const userDoc = await getDoc(doc(db, "users", email));
      if (userDoc.exists()) {
        return userDoc.data().totpSecret;
      } else {
        setError("User not found.");
        return null;
      }
    } catch (err) {
      console.error("Error fetching authenticator secret:", err);
      return null;
    }
  };

  // Handle TOTP setup
  const handleSetup = async () => {
    if (!email) {
      setError("Email is required for setup.");
      return;
    }

    // Generate TOTP Secret using OTPAuth
    const secret = new OTPAuth.Secret();
    console.log("TOTP Secret:", secret.base32);
    setTotpSecret(secret.base32); // Save secret in state for QR code generation
    setIsSetupComplete(true);

    // Save secret to Firestore
    await saveTotpSecret(email, secret.base32);
    setError(null);
  };

  // Handle TOTP login verification
  const handleLogin = async () => {
    if (!email || !totpCode) {
      setError("Email and authenticator code are required.");
      return;
    }

    const secretBase32 = await fetchTotpSecret(email);
    if (!secretBase32) {
      setError("Error retrieving authenticator secret.");
      return;
    }

    const totp = new OTPAuth.TOTP({
      secret: OTPAuth.Secret.fromBase32(secretBase32),
      issuer: "MetaCollege",
      label: email,
      algorithm: "SHA1",
      digits: 6,
      period: 30
    });

    const isValid = totp.validate({
      token: totpCode,
      window: 1 // Allow 1 time-step before and after
    });

    if (isValid !== null) {
      // alert("Login successful!");
      setError(null);

      // Notify parent that TOTP verification was successful
      if (onTotpSuccess) {
        onTotpSuccess(); // Call the parent callback
      }
    } else {
      setError("Invalid authenticator code. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">{isLoginMode ? "Login" : "Set up authenticator"}</h2>
        <form
          onSubmit={e => {
            e.preventDefault();
            isLoginMode ? handleLogin() : handleSetup();
          }}
          className="login-form"
        >
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Email"
            className="login-input"
            required
          />
          {!isLoginMode && !isSetupComplete && (
            <button type="button" onClick={handleSetup} className="login-button">
              Generate QR Code
            </button>
          )}
          {isSetupComplete && !isLoginMode && (
            <>
              <center>
                <QRCode value={`otpauth://totp/MetaCollege:${email}?secret=${totpSecret}&issuer=MetaCollege`} />
              </center>
              <p>Scan this QR code with your Authenticator app.</p>
              <p>Setup complete! You can now log in using your authenticator code.</p>
            </>
          )}
          {isLoginMode && (
            <>
              <input
                type="text"
                value={totpCode}
                onChange={e => setTotpCode(e.target.value)}
                placeholder="Enter authenticator code"
                className="login-input"
                required
              />
              <button type="submit" className="login-button">
                Login
              </button>
            </>
          )}
        </form>
        <button type="button" onClick={() => setIsLoginMode(!isLoginMode)} className="toggle-button login-button">
          Switch to {isLoginMode ? "Setup authenticator" : "Login"}
        </button>
        {error && <p className="error-text">{error}</p>}
      </div>
    </div>
  );
}

export default FirebaseLogin;
